var map = {
	"./A.png": 8380,
	"./B.png": 7362,
	"./BTC.png": 920,
	"./C.png": 4562,
	"./D.png": 3118,
	"./DC.png": 5309,
	"./E.png": 7171,
	"./F.png": 2684,
	"./G.png": 8024,
	"./H.png": 9055,
	"./I.png": 6350,
	"./J.png": 9302,
	"./K.png": 6014,
	"./L.png": 6995,
	"./M.png": 9964,
	"./N.png": 6406,
	"./O.png": 7914,
	"./P.png": 6463,
	"./Q.png": 4077,
	"./R.png": 9,
	"./S.png": 9017,
	"./T.png": 416,
	"./U.png": 7047,
	"./V.png": 4429,
	"./W.png": 3426,
	"./X.png": 3037,
	"./Y.png": 5442,
	"./Z.png": 2173
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5762;